export enum ProductType {
  Bike = 'bike',
  Sunbed = 'sunbed',
  ReportWeb = 'bike1',
  ReportOnSite = 'bike2',
  Article = 'article',
}
